export default __webpack_public_path__ + "c92b2e8ccb2aaf52dd3ace0f8fc9e83d.png";